exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".fake-button-fake-button-2tb1wJcHmwr{cursor:pointer}@media screen and (-ms-high-contrast: active){.fake-button-fake-button-2tb1wJcHmwr{color:buttonText}.fake-button-fake-button-2tb1wJcHmwr:focus{outline:2px dotted buttonText}}\n", ""]);
// Exports
exports.locals = {
	"fake-button": "fake-button-fake-button-2tb1wJcHmwr",
	"fakeButton": "fake-button-fake-button-2tb1wJcHmwr"
};